import { Fragment } from 'react';
import Meta from './../components/Meta';
import Feed from './../components/Feed';

function MapPage() {
  return (
    <Fragment>
      <Meta title="Showrunner Map" />
      <Feed mode="map" />
    </Fragment>
  );
}

export default MapPage;
